import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Page from "components/Page";
import {
    CardHeader,
    Card,
    CardBody,
    CardText,
    Button,
    Table,
    Row,
    Col,
    Alert
} from "reactstrap";
import "../../../../styles/estilos.css";
import Pagination from "react-js-pagination";
import { Textbox, Select as Select1 } from "react-inputs-validation";
import Select from 'react-select';
import {
    FetchGuardarDatosConducto,
    FetchGuardarFormaPagoRenovaciones,
    FetchObtenerConductos,
    FetchDatosDebitoAutomatico,
    setObtenerConductos
} from "../../../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { urlFVinculacion } from "../../../../constants/urls";
import { FetchPost } from '../../../../redux/actions/api';
import { setObtenerDatosDebitoAutomatico } from "../../../../redux/actions/aCotizacion";
import { urlGetPlanesPagoRenovacion, urlGetPlanesPagoPymes, urlGuardarConductoPymes, urlConsultarConductosPymes, urlGuardarFormaPagoRenovacion, urlConsultaFVinculacionAigPymes } from "../../api/urls";
import { obtenerCatalogoPaises } from "../../../../api/catalogos/catalogoService";
import { FetchRenovacionItem } from "../../redux/aRenovaciones";
import { stringABase64 } from "../../../../utils/Encriptar";

/**
 * DebitoAutomaticoPymes
 * Componente dedicado para el flujo de Débito Automático en renovaciones PYMES.
 * Obtiene el renovacionId directamente del query string, sin depender del carrito de Redux.
 */
class DebitoAutomaticoPymes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // Datos de la renovación PYMES
            renovacionId: null,
            primaTotal: '0.00',
            ramoRenovacion: '',
            idClientePagador: null,
            loadingRenovacion: true,

            // Conductos
            valSubmit: false,
            esTarjeta: false,
            validate: false,
            crearConducto: false,
            selectConducto: false,
            selectTipo: '',
            selectBanco: '',
            selectPlan: '',
            textCuenta: '',
            textFecha: '',
            datosConductoSel: '',
            codCoreTipo: '',
            nombreTipo: '',
            valCuotaCal: '0.00',
            hasTipoError: true,
            hasFechaError: true,
            hasCuentaError: true,
            hasBancoError: true,
            hasPlanError: true,
            hasValorCuotaError: false,
            hasNumCuotaError: false,
            activePage: 1,
            datosListadoConductos: { listaConductos: [], obtenerConductosIsLoading: true, obtenerConductosHasError: false },
            numeroElementos: 0,
            loadingvalue: false,
            mostrarPlanesPago: false,
            listaPaises: []
        };
        this.validateForm = this.validateForm.bind(this);
    }

    // ─── Ciclo de vida ────────────────────────────────────────────────────────

    async componentDidMount() {
        window.scrollTo(0, 0);

        // Limpiar datos de Redux para evitar mostrar datos de sesiones previas
        this.props.setDataDebitoPlanes({});
        this.props.resetConductos();

        await this.obtenerPaises();

        // Leer renovacionId del query string
        const queryParams = new URLSearchParams(this.props.location.search);
        const renovacionId = queryParams.get("renovacionId");

        if (!renovacionId) {
            this.setState({ loadingRenovacion: false });
            return;
        }

        try {
            // Cargar datos de la renovación para obtener prima, ramo e idCliente
            const dataRenovacion = await FetchRenovacionItem(renovacionId);
            if (dataRenovacion && dataRenovacion.dataRenovacion) {
                const ren = dataRenovacion.dataRenovacion;

                const rawPrima = ren.reDatosProducto && ren.reDatosProducto.rePrimaTotal
                    ? ren.reDatosProducto.rePrimaTotal
                    : '0.00';
                const num = parseFloat(rawPrima);
                const primaTotal = isNaN(num)
                    ? '0.00'
                    : num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                const ramoRenovacion = (ren.reDatosProducto && ren.reDatosProducto.reRamoProducto === 'PYMES') ? 'PYMES' : ((ren.reDatosProducto && ren.reDatosProducto.reRamo) ? ren.reDatosProducto.reRamo : '');

                const idClientePagador = (ren.reDatosPagador && ren.reDatosPagador[0] && ren.reDatosPagador[0].id)
                    ? ren.reDatosPagador[0].id
                    : null;

                this.setState({
                    renovacionId,
                    primaTotal,
                    ramoRenovacion,
                    idClientePagador
                });

                // Cargar datos de débito automático (bancos, tipos)
                this.props.listarDebitoAutomatico({
                    empresa: "AIGMETROPOLITANA",
                    ramo: ramoRenovacion
                });

                // Cargar conductos de la renovación
                this.cargarConductosRenovacion(renovacionId);
            }
        } catch (err) {
            console.error("Error cargando datos de renovación PYMES:", err);
        } finally {
            this.setState({ loadingRenovacion: false });
        }
    }

    // ─── Carga de Conductos PYMES ──────────────────────────────────────────────

    cargarConductosRenovacion = async function (renovacionId) {
        this.setState({
            datosListadoConductos: {
                listaConductos: [],
                obtenerConductosIsLoading: true,
                obtenerConductosHasError: false
            }
        });

        try {
            const resp = await FetchPost({
                url: urlConsultarConductosPymes,
                param: {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    renovacionId: renovacionId
                }
            });

            if (resp && resp.transaccion) {
                // Adapter: el backend devuelve arrayConductos
                this.setState({
                    datosListadoConductos: {
                        listaConductos: resp.arrayConductos || [],
                        obtenerConductosIsLoading: false,
                        obtenerConductosHasError: false
                    }
                });
            } else {
                this.setState({
                    datosListadoConductos: {
                        listaConductos: [],
                        obtenerConductosIsLoading: false,
                        obtenerConductosHasError: true
                    }
                });
            }
        } catch (error) {
            console.error("Error al consultar conductos:", error);
            this.setState({
                datosListadoConductos: {
                    listaConductos: [],
                    obtenerConductosIsLoading: false,
                    obtenerConductosHasError: true
                }
            });
        }
    }.bind(this);

    // ─── Paginación ────────────────────────────────────────────────────────────

    handlePageChange = function (pageNumber) {
        this.setState({ activePage: pageNumber });
    }.bind(this)

    // ─── Validación ────────────────────────────────────────────────────────────

    toggleValidating(validate) {
        this.setState({ validate });
    }

    valValorCuota = function (bandera) {
        this.setState({ hasValorCuotaError: bandera });
    }.bind(this)

    valNumCuota = function (bandera) {
        this.setState({ hasNumCuotaError: bandera });
    }.bind(this)

    valSubmitFn = function () {
        this.setState({ valSubmit: true });
    }.bind(this)

    // ─── Conductos ─────────────────────────────────────────────────────────────

    onIngresarConducto = function (e) {
        e.preventDefault();
        this.setState({ crearConducto: true });
    }.bind(this)

    onCancelarConducto = function (e) {
        e.preventDefault();
        this.setState({
            crearConducto: false,
            selectConducto: false,
            esTarjeta: false,
            selectBanco: '',
            selectTipo: '',
            selectPlan: '',
            textCuenta: '',
            valCuotaCal: '0.00',
            hasBancoError: true,
            hasPlanError: true,
            mostrarPlanesPago: false,
            valSubmit: false
        });
    }.bind(this)

    onCancelarDebito = function (e) {
        e.preventDefault();
        this.props.history.push({
            pathname: '/forma-pago-pymes',
            search: '?renovacionId=' + this.state.renovacionId
        });
    }.bind(this)

    onSelectConducto = async function (id, e) {
        e.preventDefault();
        var conductosState = this.state.datosListadoConductos.listaConductos;
        var conductosProps = this.props.datosListadoConductos.listaConductos;
        var dataConducto;

        if (conductosState.length > 0) {
            dataConducto = conductosState.find(function (c) { return c.id === id; });
        } else {
            dataConducto = conductosProps.find(function (c) { return c.id === id; });
        }

        if (dataConducto) {
            await this.cargarPlanesPorBanco(dataConducto.codigoBanco);
            this.setState({
                crearConducto: true,
                selectConducto: true,
                datosConductoSel: dataConducto,
                textCuenta: dataConducto.numeroCuentaOTarjeta,
                mostrarPlanesPago: true
            });
            // 3 corresponde a Tipo Tarjeta en catálogos
            if (dataConducto.tipoCuentaCodigo === 3 || dataConducto.tipoCuentaCodigo === "3") {
                this.setState({ esTarjeta: true });
            }
        }
    }.bind(this)

    // ─── Bancos y planes ───────────────────────────────────────────────────────

    handleChangeBanco = async function (selectBanco) {
        this.setState({ selectBanco: selectBanco, mostrarPlanesPago: false });
        this.setState({ hasBancoError: false });
        this.setState({ selectPlan: '', valCuotaCal: '0.00' });
        this.setState({ hasPlanError: true });
        await this.cargarPlanesPorBanco(selectBanco.value);
    }.bind(this)

    cargarPlanesPorBanco = async function (idbanco) {
        this.setState({ loadingvalue: true }); // Mostrar loading al obtener planes
        try {
            var resp = await FetchPost({
                url: urlGetPlanesPagoPymes + '&codBanco=' + idbanco,
                param: {
                    empresa: "AIGMETROPOLITANA",
                    ramo: this.state.ramoRenovacion,
                    bancosId: idbanco,
                    codBanco: idbanco,
                    idCarrito: this.state.renovacionId
                }
            });
            var transaccion = resp && resp.transaccion;
            if (transaccion) {
                var planesPago = resp.planesPago || [];
                var arrayplanesPago = [];
                planesPago.forEach(function (elementP) {
                    arrayplanesPago.push({
                        value: elementP.codigoCore || elementP.planCodigoCore,
                        id: elementP.id || (elementP._id && elementP._id.$oid),
                        label: (elementP.numeroCuotas || elementP.planNroCuotas) + ' Cuota(s)',
                        cuotas: elementP.numeroCuotas || elementP.planNroCuotas
                    });
                });
                var DataDebitoActual = this.props.datosDebito.debitoAuomatico;
                if (DataDebitoActual) {
                    DataDebitoActual = Object.assign({}, DataDebitoActual, { planesPago: arrayplanesPago });
                    await this.props.setDataDebitoPlanes(DataDebitoActual);
                    this.setState({ mostrarPlanesPago: true });
                } else {
                    alert('No se ha podido obtener información de los planes de pago.');
                }
            } else {
                alert('No se ha podido obtener información de los planes de pago.');
            }
        } catch (error) {
            console.error("Error obteniendo planes de pago:", error);
            alert('Error al consultar planes de pago.');
        } finally {
            this.setState({ loadingvalue: false });
        }
    }.bind(this)

    handleChangePlanPago = function (selectPlan) {
        var primaNum = parseFloat(this.state.primaTotal.replace(/,/g, ''));
        var cuotaPlan = selectPlan.cuotas;
        var calculo = 0;
        if (cuotaPlan && cuotaPlan !== 0 && primaNum && primaNum !== 0) {
            calculo = (primaNum / Number(cuotaPlan)).toFixed(2);
        }
        this.setState({ selectPlan: selectPlan, valCuotaCal: calculo });
        this.setState({ hasPlanError: false });
    }.bind(this)

    // ─── Países ────────────────────────────────────────────────────────────────

    obtenerPaises = async function () {
        var resp = await obtenerCatalogoPaises();
        if (resp && resp.transaccion && Array.isArray(resp.paises)) {
            var listaPaises = resp.paises.map(function (pais) {
                return { value: pais.paiCodigoCore, label: pais.paiNombre };
            });
            this.setState({ listaPaises: listaPaises });
            return listaPaises;
        }
        return [];
    }.bind(this)

    // ─── Transformar bancos ─────────────────────────────────────────────────────

    transformarBancos(data) {
        return data.map(function (item) {
            return Object.assign({}, item, {
                value: item.bcoCodigoCore.toString(),
                label: item.bcoDesc,
                mesesC: 12,
                mesesT: 12
            });
        });
    }

    // ─── Submit principal ──────────────────────────────────────────────────────

    async validateForm(e) {
        e.preventDefault();
        this.setState({ loadingvalue: true });
        this.toggleValidating(true);
        this.valSubmitFn();

        var selectTipo = this.state.selectTipo;
        var selectBanco = this.state.selectBanco;
        var selectPlan = this.state.selectPlan;
        var textCuenta = this.state.textCuenta;
        var textFecha = this.state.textFecha;
        var codCoreTipo = this.state.codCoreTipo;
        var nombreTipo = this.state.nombreTipo;
        var hasTipoError = this.state.hasTipoError;
        var hasBancoError = this.state.hasBancoError;
        var hasPlanError = this.state.hasPlanError;
        var hasFechaError = this.state.hasFechaError;
        var hasCuentaError = this.state.hasCuentaError;
        var esTarjeta = this.state.esTarjeta;
        var selectConducto = this.state.selectConducto;

        var validaCampos = false;
        var valorCuotaMinima = 0;
        var numCuotas = 0;
        var valorCuota = this.state.valCuotaCal;
        var cuotaPlan = selectPlan.cuotas;
        var idConducto = '';

        if (selectConducto) {
            if (!hasPlanError) {
                validaCampos = true;
                numCuotas = this.state.datosConductoSel.numeroCuotasMaximo;
                valorCuotaMinima = this.state.datosConductoSel.valorCuotaMinima;
                idConducto = this.state.datosConductoSel.id;
            }
        } else {
            if (!hasTipoError && !hasBancoError && !hasPlanError && !hasCuentaError) {
                if (esTarjeta) {
                    if (!hasFechaError) {
                        validaCampos = true;
                        numCuotas = this.state.selectBanco.mesesT;
                        valorCuotaMinima = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaTarjeta;
                    }
                } else {
                    validaCampos = true;
                    numCuotas = this.state.selectBanco.mesesC;
                    valorCuotaMinima = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaCuenta;
                }
            }
        }

        if (validaCampos) {
            this.valValorCuota(false);

            if (!selectConducto) {
                var datosJSON = {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    numeroCuentaOTarjeta: textCuenta,
                    codigoBanco: selectBanco.value,
                    tipoCuentaoTarjeta: selectTipo,
                    tipoCuentaoTarjetaCodigoCore: codCoreTipo,
                    tipoCuentaoTarjetaNombre: nombreTipo,
                    anioVencimientoTarjeta: textFecha,
                    numeroCuotasMaximo: numCuotas,
                    valorCuotaMinima: valorCuotaMinima,
                    esTitular: true,
                    renovacionId: this.state.renovacionId
                };

                const respGuardar = await FetchPost({
                    url: urlGuardarConductoPymes,
                    param: datosJSON
                });

                if (respGuardar && respGuardar.transaccion) {
                    idConducto = respGuardar.idConducto;
                    // Refrescar listado de conductos locales
                    await this.cargarConductosRenovacion(this.state.renovacionId);

                    this.setState({ crearConducto: false });
                } else {
                    alert(respGuardar.errorDescripcion || 'No se pudo guardar el conducto de pago.');
                }
            }

            if (idConducto) {
                var PagoJSON = {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    idRenovacion: this.state.renovacionId,
                    formCodigo: "debito-automatico",
                    idConducto: idConducto,
                    idPlanPago: selectPlan.id
                };

                const respPago = await FetchPost({
                    url: urlGuardarFormaPagoRenovacion,
                    param: PagoJSON
                });

                if (respPago && respPago.transaccion) {
                    // Solicitar formulario de vinculación adaptado al nuevo servicio
                    var resp = await FetchPost({
                        url: urlConsultaFVinculacionAigPymes + this.state.renovacionId,
                        param: ''
                    });
                    var transaccion = resp && resp.transaccion;
                    var pasarPantallaFormulario = resp && resp.pasarPantallaFormulario;
                    var urlFormulario = resp && resp.urlFormulario;

                    if (transaccion) {
                        if (pasarPantallaFormulario) {
                            this.props.history.push({
                                pathname: "/formulario-vinculacion-renovacion",
                                search: '?url=' + stringABase64(urlFormulario) + '&id=' + this.state.renovacionId
                            });
                        } else {
                            this.props.history.push({ pathname: '/final-cotizacionbroker-renovacion' });
                        }
                    } else {
                        this.props.history.push({ pathname: '/final-cotizacionbroker-renovacion' });
                    }
                } else {
                    alert(respPago ? (respPago.errorDescripcion || respPago.mensaje || 'Error al guardar la forma de pago') : 'Error al guardar la forma de pago');
                }
            }
        } else {
            this.valNumCuota(false);
            this.valValorCuota(false);
        }

        this.setState({ loadingvalue: false });
    }

    // ─── Render ────────────────────────────────────────────────────────────────

    render() {
        var datosListadoConductos = this.state.datosListadoConductos;
        var loadingvalue = this.state.loadingvalue;
        var loadingRenovacion = this.state.loadingRenovacion;
        var validate = this.state.validate;
        var esTarjeta = this.state.esTarjeta;
        var crearConducto = this.state.crearConducto;
        var selectConducto = this.state.selectConducto;
        var hasBancoError = this.state.hasBancoError;
        var hasPlanError = this.state.hasPlanError;
        var selectPlan = this.state.selectPlan;
        var selectBanco = this.state.selectBanco;
        var activePage = this.state.activePage;
        var mostrarPlanesPago = this.state.mostrarPlanesPago;

        var nuevosBancos = (this.props.datosDebito && this.props.datosDebito.debitoAuomatico && this.props.datosDebito.debitoAuomatico.bancos)
            ? this.props.datosDebito.debitoAuomatico.bancos
            : [];

        return (
            <LoadingScreen
                loading={
                    loadingRenovacion ||
                    this.props.datosGuardarConducto.guardarConductoIsLoading ||
                    datosListadoConductos.obtenerConductosIsLoading ||
                    this.props.datosGuardarFormaPago.guardarFormaPagoIsLoading ||
                    loadingvalue
                }
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <Page>
                    {/* Encabezado y detalle de pago */}
                    <Row className="justify-content-md-center">
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <Card>
                                <CardHeader>
                                    <h2 style={{ color: "#001871", textAlign: "center" }}>DÉBITO AUTOMÁTICO</h2>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <h3 style={{ color: "#001871" }}>Detalle de Pago</h3>
                                            <h5 style={{ textAlign: "left" }}>
                                                El Valor Total a Pagar es: <strong>$ {this.state.primaTotal}</strong>.
                                            </h5>
                                        </Col>
                                    </Row>
                                    <hr></hr>
                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Button className="btn btn-detail-white" onClick={this.onCancelarDebito}>
                                                <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
                                                {" REGRESAR A FORMAS DE PAGO "}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* Listado de conductos existentes */}
                    {crearConducto === false &&
                        <Row className="justify-content-md-center">
                            <Col lg={8} md={8} sm={8} xs={12}>
                                <Card>
                                    <CardHeader>
                                        <h3 style={{ color: "#001871", textAlign: "center" }}>Listado de Conductos</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <div className="div-align-rigth">
                                                <Button className="btn btn-purple" onClick={this.onIngresarConducto}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" />{" CREAR CONDUCTO "}
                                                </Button>
                                            </div>
                                        </Row>
                                        <br></br>
                                        {datosListadoConductos.listaConductos.length > 0 &&
                                            <div>
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Table responsive className="table-bordered" style={{ textAlign: "center" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>#</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Banco Emisor</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Número de cuenta/tarjeta</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Tipo</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Pagar</th>
                                                                </tr>
                                                            </thead>
                                                            {datosListadoConductos.listaConductos.map(function (conducto, index) {
                                                                var fin = activePage * 5;
                                                                var inicio = fin - 5;
                                                                return (
                                                                    <tbody key={conducto.id}>
                                                                        {index >= inicio && index < fin &&
                                                                            <tr>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{index + 1}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.bancoNombre}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.numeroCuentaOTarjeta}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.tipoCuentaNombre}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>
                                                                                    <Button
                                                                                        className="btn btn-primary"
                                                                                        onClick={function (e) { this.onSelectConducto(conducto.id, e); }.bind(this)}
                                                                                        style={{ display: "block", margin: "auto" }}
                                                                                    >
                                                                                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" SELECCIONAR"}
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                );
                                                            }.bind(this))}
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Pagination
                                                            activePage={this.state.activePage}
                                                            itemsCountPerPage={5}
                                                            totalItemsCount={this.state.numeroElementos}
                                                            pageRangeDisplayed={5}
                                                            onChange={this.handlePageChange}
                                                            linkClass="paginaciontaga"
                                                            activeLinkClass="activepagination"
                                                            innerClass="pagination centrarpagination"
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                        {datosListadoConductos.listaConductos.length === 0 &&
                                            <CardText>
                                                <h5 style={{ textAlign: "center" }}>NO SE HA ENCONTRADO CONDUCTOS REGISTRADOS.</h5>
                                            </CardText>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }

                    {/* Formulario de nuevo conducto / pago */}
                    {crearConducto === true &&
                        <form onSubmit={this.validateForm}>
                            <Row className="justify-content-md-center">
                                <Col lg={8} md={8} sm={8} xs={12}>
                                    <Card className="flex-row">
                                        <CardBody>
                                            <Row>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <h4 style={{ fontWeight: 'bold' }}>Datos del Pago</h4>
                                                    <p />
                                                </Col>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <div>(*) Campos Requeridos</div>
                                                </Col>
                                            </Row>

                                            {/* Banco */}
                                            <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5>Banco (*)</h5>
                                                </Col>
                                                {!selectConducto ? (
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Select
                                                            value={selectBanco}
                                                            onChange={this.handleChangeBanco}
                                                            options={nuevosBancos}
                                                            isSearchable={true}
                                                            placeholder="Seleccione una entidad financiera."
                                                            isMulti={false}
                                                        />
                                                        {hasBancoError && this.state.valSubmit &&
                                                            <span style={{ color: "red", fontSize: "0.9rem" }}>Por favor seleccione la entidad financiera.</span>
                                                        }
                                                    </Col>
                                                ) : (
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Textbox
                                                            tabIndex="1"
                                                            type="text"
                                                            id="txtBanco"
                                                            name="txtBanco"
                                                            classNameInput="input-type-label form-control"
                                                            value={this.state.datosConductoSel.bancoNombre}
                                                        />
                                                    </Col>
                                                )}
                                            </Row>

                                            {/* Tipo de cuenta */}
                                            <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5>Tipo de cuenta (*)</h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    {!selectConducto ? (
                                                        <Select1
                                                            tabIndex="6"
                                                            id="selectTipo"
                                                            name="selectTipo"
                                                            value={this.state.selectTipo}
                                                            optionList={this.props.datosDebito.debitoAuomatico.tiposConductos || []}
                                                            validate={validate}
                                                            onBlur={function () { }}
                                                            validationCallback={function (res) {
                                                                this.setState({ hasTipoError: res, validate: false });
                                                            }.bind(this)}
                                                            onChange={function (id) {
                                                                var esTarjeta = id === "3";
                                                                var dataTipo = this.props.datosDebito.debitoAuomatico.tiposConductos.find(function (t) { return t.id === id; });
                                                                this.setState({
                                                                    esTarjeta: esTarjeta,
                                                                    selectTipo: id,
                                                                    codCoreTipo: dataTipo ? dataTipo.codigoCore : '',
                                                                    nombreTipo: dataTipo ? dataTipo.name : ''
                                                                });
                                                            }.bind(this)}
                                                            customStyleOptionListContainer={{ maxHeight: "200px", overflow: "auto", fontSize: "14px" }}
                                                            validationOption={{
                                                                name: "selectTipo",
                                                                check: true,
                                                                required: true,
                                                                msgOnError: "Por favor seleccione el tipo de conducto"
                                                            }}
                                                        />
                                                    ) : (
                                                        <Textbox
                                                            tabIndex="1"
                                                            type="text"
                                                            id="txtTipo"
                                                            name="txtTipo"
                                                            classNameInput="input-type-label form-control"
                                                            value={this.state.datosConductoSel.tipoNombre}
                                                        />
                                                    )}
                                                </Col>
                                            </Row>

                                            {/* Plan de pago y número de cuenta (se muestran al seleccionar banco) */}
                                            {mostrarPlanesPago &&
                                                <div>
                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Plan de pago (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Select
                                                                value={selectPlan}
                                                                onChange={this.handleChangePlanPago}
                                                                options={this.props.datosDebito.debitoAuomatico.planesPago || []}
                                                                isSearchable={true}
                                                                placeholder="Seleccione un plan de pago."
                                                                isMulti={false}
                                                            />
                                                            {hasPlanError && this.state.valSubmit &&
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>Por favor seleccione el plan de pago.</span>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>{!esTarjeta ? "Número de cuenta (*)" : "Número de tarjeta (*)"}</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                tabIndex="1"
                                                                type="number"
                                                                id="txtCuentaTarjeta"
                                                                name="txtCuentaTarjeta"
                                                                placeholder="1234 56789 0123 4567"
                                                                classNameInput={!selectConducto ? "form-control" : "input-type-label form-control"}
                                                                value={this.state.textCuenta}
                                                                maxLength={12}
                                                                validate={validate}
                                                                onBlur={function () { }}
                                                                onChange={function (textCuenta) { this.setState({ textCuenta: textCuenta }); }.bind(this)}
                                                                validationCallback={function (res) { this.setState({ hasCuentaError: res, validate: false }); }.bind(this)}
                                                                validationOption={{
                                                                    check: true,
                                                                    required: true,
                                                                    reg: /^[0-9]{6,12}$/,
                                                                    msgOnError: "Por favor ingrese un número de cuenta"
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            }

                                            {/* Fecha de expiración para tarjetas */}
                                            {esTarjeta === true && selectConducto === false &&
                                                <Row>
                                                    <Col lg={4} md={4} sm={4} xs={12}></Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Row className="justify-content-md-center">
                                                            <Col lg={6} md={6} sm={6} xs={12}>
                                                                <h6>Fecha de expiración (*)</h6>
                                                                <Textbox
                                                                    tabIndex="1"
                                                                    type="text"
                                                                    id="txtFechaVencimiento"
                                                                    name="txtFechaVencimiento"
                                                                    placeholder="MM/YY"
                                                                    classNameInput={!selectConducto ? "form-control" : "input-type-label form-control"}
                                                                    value={this.state.textFecha}
                                                                    maxLength={5}
                                                                    validate={validate}
                                                                    onBlur={function () { }}
                                                                    onChange={function (textFecha) { this.setState({ textFecha: textFecha }); }.bind(this)}
                                                                    validationCallback={function (res) { this.setState({ hasFechaError: res, validate: false }); }.bind(this)}
                                                                    validationOption={{
                                                                        check: true,
                                                                        required: true,
                                                                        reg: /^([0-1][0-9]|[1-9])(\/)(([1-9][0-9]))$/,
                                                                        msgOnError: "La fecha de expiración es de la forma MM/YY y debe estar vigente"
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            }

                                            {/* Valor de cuota calculado */}
                                            {mostrarPlanesPago &&
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <h5 style={{ textAlign: "left" }}>
                                                            Valor de cuota aproximado: <strong>$ {this.state.valCuotaCal}</strong>
                                                        </h5>
                                                    </Col>
                                                </Row>
                                            }

                                            {/* Botones */}
                                            <Row className="justify-content-md-center">
                                                <div>
                                                    <Button
                                                        className="btn btn-primary"
                                                        onClick={this.validateForm}
                                                    >
                                                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />
                                                        {!selectConducto ? " GUARDAR" : " PAGAR"}
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        className="btn btn-detail-white"
                                                        type="button"
                                                        onClick={this.onCancelarConducto}
                                                    >
                                                        <i className="fa fa-ban" aria-hidden="true" /> CANCELAR
                                                    </Button>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </form>
                    }
                </Page>
            </LoadingScreen>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        datosBancos: state.dataRecompraPaquete,
        datosDebito: state.datosDebitoAutomatico,
        dataUsuario: state.datosUsuarios.dataUsuario,
        datosListadoConductos: state.datosListadoConductos,
        datosGuardarConducto: state.datosGuardarConducto,
        datosGuardarFormaPago: state.datosGuardarFormaPago
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        listarDebitoAutomatico: function (datos) { return dispatch(FetchDatosDebitoAutomatico(datos)); },
        guardarConducto: function (datos) { return dispatch(FetchGuardarDatosConducto(datos)); },
        guardarFormaPago: function (datos) { return dispatch(FetchGuardarFormaPagoRenovaciones(datos)); },
        listarConductos: function (datos) { return dispatch(FetchObtenerConductos(datos)); },
        resetConductos: function () { return dispatch(setObtenerConductos([])); },
        setDataDebitoPlanes: function (datos) { return dispatch(setObtenerDatosDebitoAutomatico(datos)); }
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DebitoAutomaticoPymes)
);
